import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 21v-15l5 -3l5 3v15","key":"svg-0"}],["path",{"d":"M8 21v-7","key":"svg-1"}],["path",{"d":"M3 14h10","key":"svg-2"}],["path",{"d":"M6 10a2 2 0 1 1 4 0","key":"svg-3"}],["path",{"d":"M13 13c6 0 3 8 8 8","key":"svg-4"}]]

const IconMonkeybar = createReactComponent('outline', 'monkeybar', 'Monkeybar', __iconNode);

export default IconMonkeybar;